// roving-tabindex defines the custom element `<roving-tabindex>` on import
import "roving-tabindex";
import { h } from "preact";

import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";

const { default: sheet } = CSS_MODULE_SCRIPTS
	? await import("./FocusGroup.module.css", { with: { type: "css" } })
	: await importCss("./FocusGroup.module.css", import.meta.url);
adopt(sheet);

/**
 * @typedef {object} Props
 * @property {string} selector
 * @property {"horizontal" | "vertical" | "both" | "grid"} [direction="both"] Default is `"both"`
 * @property {boolean} [loop]
 * @property {import("preact").ComponentChildren} [children]
 */

/** @param {Props} props */
export default function FocusGroup(props) {
	const { children, selector, direction = "both", loop } = props;

	return h("roving-tabindex", { selector, direction, loop }, children);
}
